<template>
    <div v-if="reservation !== null">
        <a-modal v-model="dateChangeModalVisible" title="Datums wijzigen" @ok="handleOk">
            <div>
                <p class="input-label mb-1">Vertrekdatum</p>
                <a-date-picker :allowClear='false' class="mr-2" :default-value="moment(departure_date, 'DD-MM-YYYY')" @change="onChangeDepartureDate" format="DD-MM-YYYY" />
                <a-time-picker :allowClear='false' :default-value="moment(departure_time, 'HH:mm')" @change="onChangeDepartureTime" :minute-step="5" format="HH:mm" />
            </div>

            <div>
                <p class="input-label mb-1 mt-3">Aankomstdatum</p>
                <a-date-picker :allowClear='false' class="mr-2" :default-value="moment(arrival_date, 'DD-MM-YYYY')" @change="onChangeArrivalDate" format="DD-MM-YYYY" />
                <a-time-picker :allowClear='false' :default-value="moment(arrival_time, 'HH:mm')" @change="onChangeArrivalTime" :minute-step="5" format="HH:mm" />
            </div>
            
            <div v-if="paymentMethods !== undefined">
                <p class="input-label mb-1 mt-3">Betaalmethode</p>
                <div>
                    <div>
                        <multiselect v-model="selectedPaymentMethod" track-by="method" :options="availablePaymentMethods" :custom-label="customLabel" :show-labels="false">
                            <template slot="singleLabel" slot-scope="props"><div class="d-flex h-100 align-items-center">
                                <img class="h-100" :src="props.option.image"><p class="h-100 ml-2 mb-0">{{ props.option.label }}</p>
                            </div></template>
                            <template slot="option" slot-scope="props"><div class="d-flex h-100 align-items-center">
                                <img class="h-100" :src="props.option.image"><p class="h-100 ml-2 mb-0">{{ props.option.label }}</p>
                            </div>
    <!--                              <div class="option__desc"><span class="option__title"></span></div>-->
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>

            <div>
                <div class="w-25">
                    <p class="input-label mb-1 mt-3">Nieuw tarief</p>
                    {{price | currency}}
                </div>
                <div class="w-75">

                </div>
            </div>

            <div class="mt-2" style="display: flex; flex-direction: column;">
                <a-checkbox class="ml-2 mb-2" v-model="sendMail">
                    Verstuur mail naar klant
                </a-checkbox>
                <a-checkbox v-if="(selectedPaymentMethod.method === 'ideal' || selectedPaymentMethod.method === 'creditcard')" v-model="sendMailPayment">
                    Verstuur betaalverzoek mail naar klant
                </a-checkbox>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    props: ['reservation', 'updateReservation'],
    computed: {
        user: {
        get: function () {
            return this.$store.state.user
        },
        },
    },
    data(){
        return {
            dateChangeModalVisible: false,
            departure_date: undefined,
            departure_time: undefined,
            arrival_date: undefined,
            arrival_time: undefined,
            price: 0,
            paymentMethods: undefined,
            paymentMethod: undefined,
            selectedPaymentMethod: undefined,
            availablePaymentMethods: [],
            sendMail: false,
            sendMailPayment: false,
        }
    },
    mounted(){
        this.departure_date = this.moment(this.reservation.departure_time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
        this.departure_time = this.moment(this.reservation.departure_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
        this.arrival_date = this.moment(this.reservation.arrival_time   , 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
        this.arrival_time = this.moment(this.reservation.arrival_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
        
        this.fetchPrice();
        this.fetchPaymentMethods();
    },
    watch: {
        selectedPaymentMethod(newVal){
            if(newVal.method === 'ideal' || newVal.method === 'creditcard'){
                this.sendMailPayment = true;
            }else{
                this.sendMailPayment = false;
            }
            this.fetchPrice();
        }
    },
    methods: {
        customLabel ({ label, image }) {
            return `${label}<img src="${image}" />`
        },
        customIssuersLabel ({ name, image }) {
            return `${name}<img src="${image.size1x}" />`
        },
        openModal(){
            this.dateChangeModalVisible = true;
        },
        fetchPrice(){
            const priceChangeObject = {
                departure_time: `${this.moment(this.departure_date, 'DD-MM-YYYY').format('YYYY-MM-DD')} ${this.departure_time}:00`,
                arrival_time: `${this.moment(this.arrival_date, 'DD-MM-YYYY').format('YYYY-MM-DD')} ${this.arrival_time}:00`,
                reservation_id: this.reservation.id,
                payment_method: this.selectedPaymentMethod ? this.selectedPaymentMethod.method : null
            };
            
        if(this.reservation.organization_id){
          priceChangeObject.organization_id = this.reservation.organization_id
        }
        if(this.reservation.department_id){
          priceChangeObject.department_id = this.reservation.department_id
        }
            console.log(priceChangeObject);
            this.$axios.post('/reservations/getDateChangePrice', {
                ...priceChangeObject
            }).then(response=>{
                console.log(response.data)
                this.price = response.data.price;

            })
        },
        handleOk(){
            const priceChangeObject = {
                departure_time: `${this.moment(this.departure_date, 'DD-MM-YYYY').format('YYYY-MM-DD')} ${this.departure_time}:00`,
                arrival_time: `${this.moment(this.arrival_date, 'DD-MM-YYYY').format('YYYY-MM-DD')} ${this.arrival_time}:00`,
                reservation_id: this.reservation.id,
                payment_method: this.selectedPaymentMethod ? this.selectedPaymentMethod.method : null,
                send_mail_payment: this.sendMailPayment,
                send_mail: this.sendMail,
            };
            console.log(priceChangeObject);
            this.$axios.post('/reservations/updateReservationDate', {
                ...priceChangeObject
            }, {headers: {
                'Authorization': `Bearer ${this.user.user.token}`,
            }}).then(response=>{
                this.updateReservation(response.data);
                this.dateChangeModalVisible = false;

            })
        },
        onChangeDepartureDate(date) {
            this.departure_date = date;
            this.fetchPrice();
        },
        onChangeDepartureTime(time) {
            this.departure_time = this.moment(time).format('HH:mm');
            this.fetchPrice();
        },
        onChangeArrivalDate(date) {
            this.arrival_date = date;
            this.fetchPrice();
        },
        onChangeArrivalTime(time) {
            this.arrival_time = this.moment(time).format('HH:mm');
            this.fetchPrice();
        },
        fetchPaymentMethods() {
            this.$axios.get('payment-methods', {params: {
                organization_id: (typeof this.selectedOrganization === 'object') ? this.selectedOrganization.id : null,
            }}).then((response)=>{
                this.paymentMethods = response.data;
                this.availablePaymentMethods = [];
                this.availablePaymentMethods.push({
                    label: `Op Factuur`,
                    method: 'factuur',
                    image: undefined
                })
                if(response.data.hasOwnProperty('ideal')){
                    this.idealIssuer = response.data.ideal.issuers[0];
                    this.availablePaymentMethods.push({
                        label: `${response.data.ideal.description}`,
                        method: 'ideal',
                        image: response.data.ideal.image.size1x
                    })
                }
                if(response.data.hasOwnProperty('creditcard')){
                    this.availablePaymentMethods.push({
                        label: `${response.data.creditcard.description}`,
                        method: 'creditcard',
                        image: response.data.creditcard.image.size1x
                    })
                }
                this.availablePaymentMethods.push({
                    label: `Contant betalen bij aflevering`,
                    method: 'contant',
                    image: undefined
                })
                this.availablePaymentMethods.push({
                    label: `Pinnen bij aflevering`,
                    method: 'pin',
                    image: undefined
                })
                this.selectedPaymentMethod = this.availablePaymentMethods.find((method)=>{
                    return method.method === this.reservation.payment_method
                })
            })
        },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>  
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap');

  .input-label{
    margin-bottom: 0px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
  }
</style>